<template>
  <div class="payout-detail-modal">
    <el-dialog :title="$t('components.detail')" :visible.sync="dialogTableVisible" width="1000px" class="diglog-card" @open="getDetailInfo">
      <div class="header-line" />
      <template>

        <div class="total">
          <div class="total-item">
            <div class="total-title">{{ $t('data.sell_amount') }}:</div>
            <div class="total-num">{{ merchantInfo.sell_currency }}  {{ merchantInfo.sell_amount | toDivideWithDot }}</div>
          </div>
          <div class="line" />
          <div class="total-item">
            <div class="total-title">{{ $t('data.buy_amount') }}:</div>
            <div class="total-num"> {{ merchantInfo.buy_currency }}  {{ merchantInfo.buy_amount | toDivideWithDot }}</div>
          </div>
        </div>
        <div class="total">
          <div class="total-item">
            <div class="total-title" />
            <div class="total-num" />
          </div>
        </div>
      </template>
      <div class="section-title">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.create_time') }}</span>
        <span class="content-blue">{{ $t('merchantAccount.complete_time') }}</span>
      </div>

      <div class="item">
        <span class="item-left" style="color: #4B5567">{{ merchantInfo.create_date_time }}</span>
        <span class="content-gray">{{ merchantInfo.complete_date_time }}</span>
      </div>

      <div class="section-title">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue"> {{ $t('data.fee') }}:</span>
        <span class="content-gray">{{ merchantInfo.foreign_exchange_fee_split_currency }} {{ merchantInfo.foreign_exchange_fee_split | toDivideWithDot }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('data.exchange_rate') }}</span>
        <span class="content-gray">{{ merchantInfo.exchange_rate }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('data.quote_id') }}</span>
        <span class="content-gray">{{ merchantInfo.quote_id }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.quote_time') }}</span>
        <span class="content-gray">{{ merchantInfo.quote_time }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.quote_expiry_time') }}</span>
        <span class="content-gray">{{ merchantInfo.quote_expire_time }}</span>
      </div>

      <div class="section-title">
        {{ $t('data.related_transactions') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.transaction_type') }}</span>
        <span class="content-gray">{{ getTransactionTypeMap(merchantInfo.related_transaction.transaction_type).label }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.related_transaction.transaction_id }}</span>
      </div>
      <div v-if="$store.getters.nsdsStatus" class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.nsds_payment_amount') }}</span>
        <span class="content-gray">{{ merchantInfo.foreign_exchange_fee_split_currency }} {{ merchantInfo.related_transaction.nsds_pay_amount | toDivideWithDot }}</span>
      </div>

      <div class="section-title">
        {{ $t('data.document_proof') }}
      </div>
      <div v-for="item in merchantInfo.proof_files" :key="item.id" style="margin-bottom: 10px">
        <div class="content-blue">
          <el-image
            v-if="isImg(item.file_name)"
            style="height:150px"
            :src="item.file_url"
            :preview-src-list="[item.file_url]"
          />
          <span v-else @click="onClickFile(item.file_url)">{{ item.file_name }}</span>
        </div>
      </div>

      <el-tag :type="getFxTransactionStatusMap(merchantInfo.status).type" min-width="150" class="payout-status tag-custom"> {{ getFxTransactionStatusMap(merchantInfo.status).label }}</el-tag>
    </el-dialog>
  </div>
</template>

<script>
import { foreignExchangeDetail } from '@/api/data/data'
import { transactionTypeMap, fxTransactionStatusMap } from '@/utils/maps'
export default {
  name: 'FX_Details_Modal',
  components: {
  },
  props: {
    detailId: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      listLoading: false,
      merchantInfo: {
        related_transaction: {}
      }
    }
  },
  computed: {
    isImg() {
      return function(value) {
        return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(value)
      }
    },
    getFxTransactionStatusMap() {
      return function(value) {
        return fxTransactionStatusMap(value)
      }
    },
    getTransactionTypeMap() {
      return function(value) {
        return transactionTypeMap(value)
      }
    }
  },
  mounted() {
  },
  methods: {
    initData() {
      this.merchantInfo = {
        related_transaction: {}
      }
    },
    getDetailInfo() {
      this.initData()
      const params = { transaction_id: this.detailId }
      foreignExchangeDetail(params).then(res => {
        this.merchantInfo = res.data
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogTableVisible = value
    },

    onClickCancal() {
      this.changModalStatus(false)
    },
    onClickFile(fileUrl) {
      window.open(fileUrl, '_blank')
    }
  }
}
</script>
<style>
.payout-detail-modal .el-dialog__title {
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 16px;
  color: #000000;
}
.payout-detail-modal .header-line{
  margin: -26px 0 0;
  border-bottom: 1px solid #D3D7DF;
}
</style>
<style scoped lang="scss">
.total{
  display: inline-flex;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;
  width: 580px;

  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    background: #D3D7DF;
    margin: 0 10px;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 17px;
  background: linear-gradient(180deg, #488CE8 0%, #0058CF 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;;
}
.content-gray{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.payout-detail-modal{
  .payout-status{
    text-align: center;
    position: absolute;
    top: 20px;
    left: 160px;
  }
}
</style>
